import React from "react";

interface ISocialSectionComponentProps { }

export const SocialSectionComponent: React.FC<ISocialSectionComponentProps> = (
    props: ISocialSectionComponentProps
) => {
    return (
        <div className="social-links d-flex justify-content-center">
            {/* <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-twitter-x"></i>
            </a> */}
            <a className="gradient-bg"
                href="https://www.facebook.com/share/15FsbqYXyZ/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="bi bi-facebook"></i>
            </a>
            <a className="gradient-bg"
                href="https://www.instagram.com/italent_outsourcing?igsh=MTA0a2JvNWJsNXFlMw%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="bi bi-instagram"></i>
            </a>
            {/* <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="bi bi-skype"></i>
            </a> */}
            <a  className="gradient-bg"
                href="https://in.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="bi bi-linkedin"></i>
            </a>
        </div>
    );
};
